import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "filter__body" }
const _hoisted_2 = { class: "filter__items" }
const _hoisted_3 = { class: "filter__items" }
const _hoisted_4 = { class: "filter__row" }
const _hoisted_5 = { class: "filter__row" }
const _hoisted_6 = { class: "filter__price" }
const _hoisted_7 = { class: "filter__price-checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSProductsFilter = _resolveComponent("FTSProductsFilter")!
  const _component_FTSCountriesFilter = _resolveComponent("FTSCountriesFilter")!
  const _component_FTSOkatoFilter = _resolveComponent("FTSOkatoFilter")!
  const _component_FTSMonthlyPeriodField = _resolveComponent("FTSMonthlyPeriodField")!
  const _component_FTSCustomProcedureField = _resolveComponent("FTSCustomProcedureField")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_FTSTradeDirectionField = _resolveComponent("FTSTradeDirectionField")!
  const _component_FTSCumulativeTotalField = _resolveComponent("FTSCumulativeTotalField")!
  const _component_FTSAdditionalUnitsField = _resolveComponent("FTSAdditionalUnitsField")!
  const _component_FTSFilterWrapperToogle = _resolveComponent("FTSFilterWrapperToogle")!
  const _component_FTSIndicatorTypeField = _resolveComponent("FTSIndicatorTypeField")!
  const _component_FTSWeightField = _resolveComponent("FTSWeightField")!
  const _component_FTSPriceField = _resolveComponent("FTSPriceField")!
  const _component_FTSSectionField = _resolveComponent("FTSSectionField")!
  const _component_FTSFilterWrapper = _resolveComponent("FTSFilterWrapper")!

  return (_openBlock(), _createBlock(_component_FTSFilterWrapper, {
    class: "filter",
    onSearch: _ctx.searchFilter,
    onInit: _ctx.initFilter,
    onLoad: _ctx.loadFilter,
    filter: _ctx.filter,
    defaultFilter: _ctx.defaultFilter,
    filePrefixName: "monthly",
    isReadonly: _ctx.isReadonly,
    exportConfig: _ctx.exportConfig
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_FTSProductsFilter, {
            modelValue: _ctx.filter,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FTSCountriesFilter, {
            modelValue: _ctx.filter,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_FTSOkatoFilter, {
            modelValue: _ctx.filter,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FTSMonthlyPeriodField, {
              modelValue: _ctx.filter.periods,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter.periods) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_FTSCustomProcedureField, {
              modelValue: _ctx.filter.customsProcedureIds,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filter.customsProcedureIds) = $event)),
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createVNode(_component_ComponentInput, {
            modelValue: _ctx.filter.isLoadWeeklyData,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filter.isLoadWeeklyData) = $event)),
            id: "load-weekly-data",
            type: "checkbox",
            label: "Подгружать недельные данные",
            mod: "checkbox-green",
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_FTSTradeDirectionField, {
            modelValue: _ctx.filter.tradeDirectionId,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filter.tradeDirectionId) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_FTSFilterWrapperToogle, null, {
            default: _withCtx(() => [
              _createVNode(_component_FTSCumulativeTotalField, {
                modelValue: _ctx.filter.isCumulativeTotal,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filter.isCumulativeTotal) = $event)),
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_FTSAdditionalUnitsField, {
                modelValue: _ctx.filter.isAdditionalUnits,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filter.isAdditionalUnits) = $event)),
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_ComponentInput, {
                modelValue: _ctx.filter.isAdditionalUnitsWithQuantity,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filter.isAdditionalUnitsWithQuantity) = $event)),
                id: "additional-units-with-quantity",
                type: "checkbox",
                label: "Ед. + кол-во",
                mod: "checkbox-green",
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_FTSIndicatorTypeField, {
            modelValue: _ctx.filter.indicatorTypeId,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filter.indicatorTypeId) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_FTSWeightField, {
            modelValue: _ctx.filter.weightId,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filter.weightId) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_FTSPriceField, {
            modelValue: _ctx.filter.costInId,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filter.costInId) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_FTSSectionField, {
            modelValue: _ctx.filter.showSectionId,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filter.showSectionId) = $event)),
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ComponentInput, {
              modelValue: _ctx.filter.isTotalShare,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filter.isTotalShare) = $event)),
              id: "total-share",
              type: "checkbox",
              label: "Доля к итогу",
              mod: "checkbox-green",
              disabled: _ctx.isReadonly
            }, null, 8, ["modelValue", "disabled"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ComponentInput, {
                  modelValue: _ctx.filter.isMoreCost,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filter.isMoreCost) = $event)),
                  id: "more-cost",
                  type: "checkbox",
                  label: "Стоимость ≥",
                  mod: "checkbox-green",
                  disabled: _ctx.isReadonly
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _createVNode(_component_ComponentInput, {
                modelValue: _ctx.filter.moreCost,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.filter.moreCost) = $event)),
                type: "number",
                maxLength: 50,
                placeholder: "Введите",
                mod: "rectangular",
                disabled: _ctx.isReadonly
              }, null, 8, ["modelValue", "disabled"])
            ])
          ]),
          _createVNode(_component_ComponentInput, {
            modelValue: _ctx.filter.isProductsInGroups,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filter.isProductsInGroups) = $event)),
            id: "products-in-groups",
            type: "checkbox",
            label: "Товары в группах",
            mod: "checkbox-green",
            disabled: _ctx.isReadonly
          }, null, 8, ["modelValue", "disabled"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSearch", "onInit", "onLoad", "filter", "defaultFilter", "isReadonly", "exportConfig"]))
}